export default "__VITE_ASSET__DDnVp2G8__"